export default [
    {
        "value": "AlexBrush",
        "label": "Alex Brush",
        "preview": "alex_brush.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Allura",
        "label": "Allura",
        "preview": "allura.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "AmaticSC",
        "label": "AmaticSC",
        "preview": "amaticsc.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "ArabicTypesetting",
        "label": "Arabic Typesetting",
        "preview": "arabic_typesetting.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "ArbutusSlab",
        "label": "Arbutus Slab",
        "preview": "arbutus_slab.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "BallroomTango",
        "label": "Ballroom Tango",
        "preview": "ballroom_tango.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Bellefair",
        "label": "Bellefair",
        "preview": "bellefair.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Bellota",
        "label": "Bellota",
        "preview": "bellota.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "BellotaLight",
        "label": "Bellota Light",
        "preview": "bellota_light.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "BohemeFloral",
        "label": "Boheme Floral",
        "preview": "boheme_floral.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Chonburi",
        "label": "Chonburi",
        "preview": "chonburi.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Cinzel",
        "label": "Cinzel",
        "preview": "cinzel.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "CinzelDecorative",
        "label": "Cinzel Decorative",
        "preview": "cinzel_decorative.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Cormorant",
        "label": "Cormorant",
        "preview": "cormorant.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "DancingScript",
        "label": "Dancing Script",
        "preview": "dancing_script.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "FleurDeLeah",
        "label": "Fleur De Leah",
        "preview": "fleur_de_leah.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Garamond",
        "label": "Garamond",
        "preview": "garamond.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "Garineldo",
        "label": "Garineldo",
        "preview": "garineldo.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "GreatVibes",
        "label": "Great Vibes",
        "preview": "great_vibes.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Havana",
        "label": "Havana",
        "preview": "havana.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Kurale",
        "label": "Kurale",
        "preview": "kurale.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Lato",
        "label": "Lato",
        "preview": "lato.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "LatoHairline",
        "label": "Lato Hairline",
        "preview": "lato_hairline.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "LatoLight",
        "label": "Lato Light",
        "preview": "lato_light.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "LibreBaskerville",
        "label": "Libre Baskerville",
        "preview": "libre_baskerville.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "MonteCarlo",
        "label": "MonteCarlo",
        "preview": "montecarlo.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "OpenSans",
        "label": "Open Sans",
        "preview": "open_sans.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "Parisienne",
        "label": "Parisienne",
        "preview": "parisienne.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "PlayfairDisplaySC",
        "label": "Playfair Display SC",
        "preview": "playfair_display_sc.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "PoiretOne",
        "label": "Poiret One",
        "preview": "poiret_one.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Poppins",
        "label": "Poppins",
        "preview": "poppins.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "PoppinsLight",
        "label": "Poppins Light",
        "preview": "poppins_light.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Raleway",
        "label": "Raleway",
        "preview": "raleway.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "RalewayLight",
        "label": "Raleway Light",
        "preview": "raleway_light.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "RalewayThin",
        "label": "Raleway Thin",
        "preview": "raleway_thin.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "RetroSignature",
        "label": "Retro Signature",
        "preview": "retro_signature.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Sacramento",
        "label": "Sacramento",
        "preview": "sacramento.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "ScopeOne",
        "label": "Scope One",
        "preview": "scope_one.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Stalemate",
        "label": "Stalemate",
        "preview": "stalemate.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Sydnee",
        "label": "Sydnee",
        "preview": "sydnee.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Taviraj",
        "label": "Taviraj",
        "preview": "taviraj.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "TavirajLight",
        "label": "Taviraj Light",
        "preview": "taviraj_light.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "TavirajThin",
        "label": "Taviraj Thin",
        "preview": "taviraj_thin.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "Thasadith",
        "label": "Thasadith",
        "preview": "thasadith.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "Tinos",
        "label": "Tinos",
        "preview": "tinos.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "TrullySignature",
        "label": "Trully Signature",
        "preview": "trully_signature.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Unna",
        "label": "Unna",
        "preview": "unna.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "WatermelonScript",
        "label": "Watermelon Script",
        "preview": "watermelon_script.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Windsong",
        "label": "Windsong",
        "preview": "windsong.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Licorice",
        "label": "Licorice",
        "preview": "licorice.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Caveat",
        "label": "Caveat",
        "preview": "caveat.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Comforter",
        "label": "Comforter",
        "preview": "comforter.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Gwendolyn",
        "label": "Gwendolyn",
        "preview": "gwendolyn.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Pacifico",
        "label": "Pacifico",
        "preview": "pacifico.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "PlayfairDisplay",
        "label": "Playfair Display",
        "preview": "playfair_display.png",
        "custom": true,
        "bold": true,
        "italic": true,
        "boldItalic": true
    },
    {
        "value": "Courgette",
        "label": "Courgette",
        "preview": "courgette.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "MsMadi",
        "label": "Ms Madi",
        "preview": "ms_madi.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "MeaCulpa",
        "label": "Mea Culpa",
        "preview": "mea_culpa.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "ImperialScript",
        "label": "Imperial Script",
        "preview": "imperial_script.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Updock",
        "label": "Updock",
        "preview": "updock.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Birthstone",
        "label": "Birthstone",
        "preview": "birthstone.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "MeowScript",
        "label": "Meow Script",
        "preview": "meow_script.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "TheNautigal",
        "label": "The Nautigal",
        "preview": "the_tautigal.png",
        "custom": true,
        "bold": true,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Lora",
        "label": "Lora",
        "preview": "lora.png",
        "custom": true,
        "bold": false,
        "italic": true,
        "boldItalic": false
    },
    {
        "value": "OoohBaby",
        "label": "Oooh Baby",
        "preview": "oooh_baby.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Maisondefleur",
        "label": "Maison de fleur",
        "preview": "none.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Monterey",
        "label": "Monterey",
        "preview": "none1.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    },
    {
        "value": "Ballet",
        "label": "Ballet",
        "preview": "ballet.png",
        "custom": true,
        "bold": false,
        "italic": false,
        "boldItalic": false
    }
]